import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { href: "/games/nfg-crash", label: "Crash" },
  { href: "/#games", label: "Games" },
  { href: "/prints", label: "Prints" },
  { href: "/#install", label: "Install" },
  { href: "/#leaderboard", label: "Board" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  }, [location.pathname, location.hash]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-3 md:py-4"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-3 sm:px-6 md:px-8 ${
          scrolled ? "glass-panel border border-purple-500/20 shadow-lg shadow-black/40" : ""
        }`}
        style={{ transition: "all .35s ease" }}
      >
        <div className="flex items-center justify-between gap-3 px-2 sm:px-3 py-2">
          <Link
            to="/"
            data-testid="logo-link"
            className="flex items-center gap-2 sm:gap-3 group shrink-0 min-w-0"
          >
            <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-md border border-purple-400/60 bg-black shrink-0">
              <span className="absolute inset-0 rounded-md bg-purple-400/10 blur-md" />
              <span className="font-display font-black text-purple-300 text-sm relative">Y</span>
            </span>
            <span className="font-display font-black text-white tracking-tight text-base sm:text-lg truncate">
              Y666<span className="neon-text-cyan">.</span>SUF
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-0.5 flex-1 justify-center">
            {links.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-3 py-2 rounded-full text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-purple-300 hover:bg-purple-400/5 transition-colors whitespace-nowrap"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <a
              href="/play"
              data-testid="navbar-play-cta"
              className="btn-neon text-[0.65rem] hidden sm:inline-flex !px-3 !py-2"
            >
              Play
            </a>
            <a
              href="https://www.tiktok.com/@y666.suf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-tiktok-cta"
              className="btn-ghost text-[0.65rem] hidden md:inline-flex !px-3 !py-2"
            >
              @y666.suf
            </a>
            <button
              type="button"
              className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-purple-400/40 text-purple-300"
              aria-expanded={open}
              aria-label="Menu"
              data-testid="navbar-menu-toggle"
              onClick={() => setOpen((v) => !v)}
            >
              {open ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {open && (
          <div
            className="lg:hidden border-t border-white/10 px-3 py-3 flex flex-col gap-1"
            data-testid="navbar-mobile-menu"
          >
            {links.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className="rounded-xl px-3 py-3 text-sm font-mono uppercase tracking-widest text-zinc-300 hover:bg-purple-400/10 hover:text-purple-200"
              >
                {l.label}
              </Link>
            ))}
            <a
              href="/play"
              className="rounded-xl px-3 py-3 text-sm font-mono uppercase tracking-widest text-purple-300"
            >
              Play NFG Crash
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
